import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UiService {

  private cantidadTabsSource = new BehaviorSubject<number>(0);
  cantidadTabs$ = this.cantidadTabsSource.asObservable();

  constructor() { }

  setCantidadTabs(cantidad: number) {
    this.cantidadTabsSource.next(cantidad);
  }

  getCantidadTabs(): number {
    return this.cantidadTabsSource.value;
  }
  
}
